import Actions from 'redux/actions'
import type { CallAPIAction, Status } from 'api/types'
import { CheckLaborerProSurveyEligibilityResponse } from 'api/laborerPortalAPI/authContract'

type State = {
  eligible: boolean
} & Status

const initialState = {
  isLoading: false,
  success: false,
  fail: false,
  eligible: false,
}

export default (
  state: State = initialState,
  action: CallAPIAction<
    Actions.CHECK_LABORER_PRO_SURVEY_ELIGIBILITY_ASYNC,
    Actions.CHECK_LABORER_PRO_SURVEY_ELIGIBILITY_SUCCESS,
    Actions.CHECK_LABORER_PRO_SURVEY_ELIGIBILITY_FAIL,
    CheckLaborerProSurveyEligibilityResponse
  >,
): State => {
  switch (action.type) {
    case Actions.CHECK_LABORER_PRO_SURVEY_ELIGIBILITY_ASYNC:
    case Actions.CHECK_LABORER_PRO_SURVEY_ELIGIBILITY_FAIL: {
      return {
        ...state,
        ...action.status,
      }
    }
    case Actions.CHECK_LABORER_PRO_SURVEY_ELIGIBILITY_SUCCESS: {
      return {
        ...state,
        ...action.status,
        eligible: action.payload.eligible,
      }
    }
    default:
      return state
  }
}
